module.exports = __webpack_public_path__ + "flakes@2x.jpg?31177e1fe6c2c40e76ddccc3da97132d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flakes@2x.jpg
// module id = 193
// module chunks = 0